import { useState, useCallback } from 'react';
import {
  getCustomGroups as apiGetCustomGroups,
} from '../api/customGroupsHttpClient';
import { CustomGroup, CustomGroupRequest } from '../api/models/CustomGroup';

export const useCustomGroups = () => {
  const [customGroups, setCustomGroups] = useState<CustomGroup[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchCustomGroups = useCallback(async (projectId: string, toolId: string) => {
    setLoading(true);
    setError(null);
    try {
      const data = await apiGetCustomGroups(projectId, toolId);
      setCustomGroups(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  }, []);

  const createCustomGroup = useCallback(async (request: CustomGroupRequest) => {
    setLoading(true);
    setError(null);
    try {
      await createCustomGroup(request);
      
      // Refresh the list after creation
      await fetchCustomGroups(request.projectId, request.toolId);
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      return false;
    } finally {
      setLoading(false);
    }
  }, [fetchCustomGroups]);

  const deleteCustomGroup = useCallback(async (request: CustomGroupRequest) => {
    setLoading(true);
    setError(null);
    try {
      await deleteCustomGroup(request);
      
      // Refresh the list after deletion
      await fetchCustomGroups(request.projectId, request.toolId);
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
      return false;
    } finally {
      setLoading(false);
    }
  }, [fetchCustomGroups]);

  return {
    customGroups,
    loading,
    error,
    fetchCustomGroups,
    createCustomGroup,
    deleteCustomGroup,
  };
};